import { useEffect } from "react";
import * as React from "react";
import { useNavigate } from "react-router-dom";

import { CenterSpinner } from "components/CenterSpinner";

export const MainRedirector: React.FC<{}> = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/");
  }, [navigate]);

  return <CenterSpinner size="large" />;
};
